export enum ContactRelationship {
  Mother = 'mother',
  Father = 'father',
  Grandparent = 'grandparent',
  Sibling = 'sibling',
  Aunt = 'aunt',
  Uncle = 'uncle',
  StepFather = 'step_father',
  StepMother = 'step_mother',
  Nanny = 'nanny',
  Guardian = 'guardian',
  Other = 'other'
};

export const ContactRelationshipValues: string[] = Object.values(ContactRelationship)

export const ContactRelationshipLabels: Record<ContactRelationship, string> = {
  [ContactRelationship.Mother]: "Mother",
  [ContactRelationship.Father]: "Father",
  [ContactRelationship.Grandparent]: "Grandparent",
  [ContactRelationship.Sibling]: "Sibling",
  [ContactRelationship.Aunt]: "Aunt",
  [ContactRelationship.Uncle]: "Uncle",
  [ContactRelationship.StepFather]: "Step-father",
  [ContactRelationship.StepMother]: "Step-mother",
  [ContactRelationship.Nanny]: "Nanny",
  [ContactRelationship.Guardian]: "Guardian",
  [ContactRelationship.Other]: "Other",
}

export const ContactRelationshipFormOptions = Object.entries(ContactRelationshipLabels).map(([value, label]) => ({label, value}))

// What the duplicate query sends per contact. The staff form fields, the parent
// add-contact fields, and a stored PlayerContact all satisfy it.
export interface IPlayerContactCandidate {
  name?: string;
  email?: string;
  phone?: string;
}

export enum ContactDuplicateField {
  Email = 'email',
  Phone = 'phone',
  Name = 'name'
}

// One match the server reported: which field collided, and whose row it hit.
export interface IContactDuplicateMatch {
  field: ContactDuplicateField;
  contactName?: string;
}
